<template>
    <!-- parcel navi start -->
    <div class="floor-title-box">
        <div class="join bg-base-100 drop-shadow-lg bg-opacity-90 backdrop-blur">
            <div class="join-item">
                <div class="flex flex-col items-start p-2 w-36 sm:w-44 ml-1">
                    <div class="text-base-content font-bold">{{ parcelTitle }}</div>
                    <div
                        class="text-base-content/80 font-bold text-xs"
                    >{{ layerTitle }}</div>
                </div>
            </div>
            <div
                class="dropdown dropdown-bottom dropdown-end join-item bg-neutral place-content-center"
            >
                <div
                    tabindex="0"
                    role="button"
                    class="btn btn-square btn-ghost w-8 m-1"
                >
                    <span
                        class="material-symbols-outlined notranslate fill-current"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            height="24px"
                            viewBox="0 -960 960 960"
                            width="24px"
                            fill="#ffffffff"
                        >
                            <path
                                d="M480-345 240-585l56-56 184 183 184-183 56 56-240 240Z"
                            />
                        </svg>
                    </span>
                </div>
                <ul
                    tabindex="0"
                    class="dropdown-content z-[1] menu shadow bg-base-100 w-60 mt-2 rounded-none"
                >
                    <li
                        v-for="item in otherParcels"
                        :key="'select-parcel-id-' + item.id"
                        v-show="item.id != parcelId"
                    >
                        <div
                            class="flex justify-between flex-none px-2"
                            @click="goToParcel(item.id)"
                        >
                            <div>{{ item.title }}</div>
                            <span
                                class="material-symbols-outlined notranslate fill-current"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    height="14px"
                                    viewBox="0 -960 960 960"
                                    width="14px"
                                    fill="#000000"
                                >
                                    <path
                                        d="m321-80-71-71 329-329-329-329 71-71 400 400L321-80Z"
                                    />
                                </svg>
                            </span>
                        </div>
                    </li>
                    <li>
                        <div
                            class="flex justify-between flex-none px-2"
                            @click="hasParentId ? goToParentParcelMap() : goToMainMap()"
                        >
                            <div>{{ trans.right_menu.main_map }}</div>
                            <span
                                class="material-symbols-outlined notranslate fill-current"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    height="14px"
                                    viewBox="0 -960 960 960"
                                    width="14px"
                                    fill="#000000"
                                >
                                    <path
                                        d="m321-80-71-71 329-329-329-329 71-71 400 400L321-80Z"
                                    />
                                </svg>
                            </span>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <!-- parcel navi end -->
</template>

<script>
export default {
    props: {
        layerTitle: {
            type: String,
            required: true,
        },
        parcelTitle: {
            type: String,
            required: true,
        },
        goToMainMap: {
            type: Function,
            required: true,
        },
        trans: {
            type: Object,
            required: true,
        },
        goToParentParcelMap: {
            type: Function,
            required: false,
        },
        hasParentId: {
            type: Boolean,
            default: false,
        },
        otherParcels: {
            type: Array,
            default: function () {
                return [];
            },
        },
        parcelId: {
            type: Number,
            required: true,
        },
        categoryId: {
            type: Number,
            default: 0
        }
    },
    methods: {
        goToParcel(id) {
            const mapHashID = window.location.pathname.split('/')[2];
            var locale = window.location.pathname.split('/')[5];
            var href = locale ? `/maps/${mapHashID}/parcels/${id}/${locale}` : `/maps/${mapHashID}/parcels/${id}`;
            window.open(!this.categoryId ? href : href + '?c=' + this.categoryId, '_self');
        },
    },
};
</script>

<style></style>